import React, { useState, useEffect } from "react";
import { Helmet } from "react-helmet";
import {ReactTyped} from "react-typed";
import { faMailBulk } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
	faGithub,
	faInstagram,
	faLinkedin,
} from "@fortawesome/free-brands-svg-icons";

import Logo from "../components/common/logo";
import Footer from "../components/common/footer";
import NavBar from "../components/common/navBar";
import Article from "../components/homepage/article";
import Works from "../components/homepage/works";
import AllProjects from "../components/projects/allProjects";

import INFO from "../data/user";
import SEO from "../data/seo";
import myArticles from "../data/portfolio";

import "./styles/homepage.css";

const Homepage = () => {
	// const [stayLogo, setStayLogo] = useState(false);
	// const [logoSize, setLogoSize] = useState(80);
	// const [oldLogoSize, setOldLogoSize] = useState(80);


	const currentSEO = SEO.find((item) => item.page === "home");


	return (
		<React.Fragment>
			<Helmet>
				<title>{INFO.main.title}</title>
				<meta name="description" content={currentSEO.description} />
				<meta
					name="keywords"
					content={currentSEO.keywords.join(", ")}
				/>
			</Helmet>

			<div className="page-content" style = {{overflow:'hidden'}}>
				<NavBar active="home" />
				<div className="content-wrapper">
					<div className="homepage-container">
						<div className="homepage-first-area">
							<div className="homepage-first-area-left-side">
								<div className="title homepage-title">
									{INFO.homepage.title}
								</div>

								<div className="subtitle homepage-subtitle">
									{INFO.homepage.description}
									<span style={{ display: 'inline-block', minWidth: '200px', textAlign: 'left' }}>
									<ReactTyped
										strings={[
											"Front-End Development.",
											"Machine Learning.",
											"Data Science.",
											"iOS Development.",
											"Photography."
										]}
										loop
										typeSpeed={60}
										backSpeed={40}
									/>
								</span>
								</div>
								
							</div>

							{/* <div className="homepage-first-area-right-side">
								<div className="homepage-image-container">
									<div className="homepage-image-wrapper">
										<img
											src="homepage.jpg"
											alt="about"
											className="homepage-image"
										/>
									</div>
								</div>
							</div> */}
						</div>

						<div className="homepage-socials">
							<a
								href={INFO.socials.github}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faGithub}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={INFO.socials.linkedin}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faLinkedin}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={INFO.socials.instagram}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faInstagram}
									className="homepage-social-icon"
								/>
							</a>
							<a
								href={`mailto:${INFO.main.email}`}
								target="_blank"
								rel="noreferrer"
							>
								<FontAwesomeIcon
									icon={faMailBulk}
									className="homepage-social-icon"
								/>
							</a>

							
						</div>

					</div>
				</div>
				<div className="page-footer">
							<Footer />
				</div>
			</div>
		</React.Fragment>
	);
};

export default Homepage;
